import { render } from "./RadioModalComponent.vue?vue&type=template&id=5c064477&scoped=true"
import script from "./RadioModalComponent.vue?vue&type=script&lang=js"
export * from "./RadioModalComponent.vue?vue&type=script&lang=js"

import "./RadioModalComponent.vue?vue&type=style&index=0&id=5c064477&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c064477"]])

export default __exports__